import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

/**
 * Uses the Web Share API when available (native OS share sheet on mobile,
 * some desktop browsers). Falls back to clipboard copy with a toast.
 */
export default function ShareButton({ title, text, url, className = "", label = "Share", testId = "share-btn" }) {
  const handleShare = async () => {
    const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url: shareUrl });
        return;
      } catch {
        /* user cancelled — fall through to clipboard */
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Could not copy link — try again");
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-white border border-navy/20 text-navy text-sm font-medium hover:bg-sand/40 transition-colors ${className}`}
      data-testid={testId}
    >
      <Share2 className="w-4 h-4" /> {label}
    </button>
  );
}
